import { getGridImageWithParagraphProps } from "../live-board-tabs-service";

const firstRow = [
  getGridImageWithParagraphProps({
    imageSrc:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/dashboard_views.png",
    fullParagraphTitle: "Dashboard"
  }),
  getGridImageWithParagraphProps({
    imageSrc:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/dashboard_views.png",
    fullParagraphTitle: "Gantt"
  }),
  getGridImageWithParagraphProps({
    imageSrc:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/dashboard_views.png",
    fullParagraphTitle: "Timeline"
  }),
  getGridImageWithParagraphProps({
    imageSrc:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/dashboard_views.png",
    fullParagraphTitle: "Files Gallery"
  })
];

const secondRow = [
  getGridImageWithParagraphProps({
    imageSrc:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/dashboard_views.png",
    fullParagraphTitle: "Dashboard"
  }),
  getGridImageWithParagraphProps({
    imageSrc:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/dashboard_views.png",
    fullParagraphTitle: "Gantt"
  }),
  getGridImageWithParagraphProps({
    imageSrc:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/dashboard_views.png",
    fullParagraphTitle: "Timeline"
  }),
  getGridImageWithParagraphProps({
    imageSrc:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/dashboard_views.png",
    fullParagraphTitle: "Files Gallery"
  })
];

export const viewsGridItems = [firstRow, secondRow];
